import { firestore } from '@/firebaseConfig'
import BasicStatistics from '@/model/BasicStatistics';

export default class StatisticsService {
    loadPublisherYearBasicStatistics(publisherId, year) {
        const promise = new Promise((resolve, reject) => {
            if (publisherId && year) {
                firestore.collection("analytics").doc("basic").collection(year.toString()).where("publisherId", "==", publisherId).get().then((querySnapshot) => {
                    const result = [];

                    querySnapshot.forEach((doc) => {
                        result.push(new BasicStatistics(doc.data()));
                    });

                    resolve(result)
                }).catch((error) => {
                    reject(error);
                });
            } else {
                resolve(null);
            }
        });

        return promise;
    }

    loadPublisherMonthSummaryBasicStatistics(publisherId, year, month) {
        const promise = new Promise((resolve, reject) => {
            if (publisherId && year && month) {
                firestore.collection("analytics").doc("basic").collection(year.toString()).where("month", "==", month).where("publisherId", "==", publisherId).get().then((querySnapshot) => {
                    const result = {};

                    querySnapshot.forEach((doc) => {
                        const data = doc.data();
                        const eventId = data.category + "_" + data.event
                        
                        var value = result[eventId];
                        if (!value) {
                            result[eventId] = data.value;
                        } else {
                            result[eventId] = value + data.value;
                        }
                    });

                    resolve(result);
                }).catch((error) => {
                    reject(error);
                });
            }
        });

        return promise;
    }
}
